<script>
    import TopBottomSplitter from './TopBottomSplitter.svelte';
    export let bottomRow = true;
</script>

<style>
    .wrapper {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 100%;
    }
    .top-row {
        flex: 1;
        overflow-y: hidden;
    }

    .bottom-row {
        background-color: rgb(212, 173, 173);
        height: 250px;
    }
</style>

<div class="wrapper">
    <div class="top-row">
        <slot name="top" />
    </div>
    {#if bottomRow}
    <TopBottomSplitter />
    <div class="bottom-row">
        <slot name="bottom" />
    </div>
    {/if}
</div>
